<template>
  <div class="row">
    <div class="o-search-result-card columns" v-if="post.post_type == 'post'">
      <a :href="post.link">
        <h5 class="o-search-result-card__title h-lower">{{ post.title }}</h5>
        <p class="o-search-result-card__date">Posted: {{ post.date }}, Trip Ideas</p>
      </a>
    </div>

    <div class="o-search-result-card columns" v-if="post.post_type == 'archive_page'">
      <a :href="post.link">
        <h5 class="o-search-result-card__title h-lower">{{ post.title }}</h5>
        <p class="o-search-result-card__date">Explore</p>
      </a>
    </div>

    <div class="o-search-result-card columns" v-if="post.post_type == 'tribe_events'">
      <a :href="post.url">
        <h5 class="o-search-result-card__title h-lower">{{ post.title }}</h5>
        <p class="o-search-result-card__date">Posted: {{ post.date }}, Festivals</p>
      </a>
    </div>

    <div class="o-search-result-card columns" v-if="post.post_type == 'listing'">
      <a :href="post.link">
        <h5 class="o-search-result-card__title h-lower">{{ post.title }}</h5>
        <p class="o-search-result-card__date">Listing</p>
      </a>
    </div>



  </div>
</template>

<script>

  export default {

    name: 'SearchTile',

    props: {
      post: {
        type: Object,
      },
      url: {
        type: String
      },
      viewType: {
        type: String
      }
    },

    mounted () {
      this.callFoundation();
    },

    methods: {
        // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
        })
      },

      /**
      * Convert a title to url title
      * @param {title}
      * @return {url_title}
      */
      titleToUrlTitle (title) {
        return title
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-');
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/vue-partials/search-tile.vue